import { ReactNode, useEffect } from 'react';
import { createRoot, Root } from 'react-dom/client';
import { useLocation } from 'react-router-dom';

type RootKey = 'lxSelectorContainer' | 'lxSelectorBackgroundContainer';

const rendereds = new Map<string, boolean>();
const roots = new Map<string, Root>();

const useRoot = () => {
  const location = useLocation();

  const keys: RootKey[] = [
    'lxSelectorContainer',
    'lxSelectorBackgroundContainer',
  ];

  const init = () => {
    keys.map(appendBodyToContainer);
  };

  const appendBodyToContainer = (id: string) => {
    const body = document.body;
    const overlayContainer = document.createElement('div');
    overlayContainer.id = id;
    overlayContainer.style.position = 'absolute';
    overlayContainer.style.top = '0px';
    overlayContainer.style.left = '0px';
    overlayContainer.style.width = '100%';
    body.appendChild(overlayContainer);
    const newRoot = createRoot(overlayContainer);
    rendereds.set(id, false);
    roots.set(id, newRoot);
  };

  const clearAllChildren = () => {
    roots.forEach((root, key) => {
      if (rendereds.get(key)) {
        rendereds.set(key, false);
        root.unmount();
      }
    });
    init();
  };

  const render = (key: RootKey, child: ReactNode) => {
    rendereds.set(key, true);
    return roots.get(key)!.render(child);
  };

  useEffect(() => {
    const timer = setTimeout(clearAllChildren);
    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return {
    init,
    clearAllChildren,
    render,
  };
};

export default useRoot;
